import React, { Component } from 'react';
import {  BrowserRouter as Router, HashRouter, Route, Link } from 'react-router-dom';
import './index.css'
import 'bootstrap/dist/css/bootstrap.css'
import NavigationBar from './NavigationBar.js'
import Footer from './Footer.js'
import CurrentlyRevised from './CurrentlyRevised.js'
import Imprint from './Imprint.js'
import Home from './Home.js'
import Chamber from './Chamber.js'
import Accomplishments from './Accomplishments.js'
import Contact from './Contact.js'
import Privacy from './Privacy.js'
import Way from './Way.js'
import Background from './Background.js'

class App extends Component {
  render() {
    return (
      <div>
        <Background />
        <div id="wrap">
          <div id="main" className="container clear-top">
            <HashRouter>
              <div id="content">
                <NavigationBar key="navBar" />
                <Route exact={true} path="/" component={Home} />
                <Route exact={true} path="/diekanzlei" component={Chamber }/>
                <Route exact={true} path="/leistungen" component={Accomplishments} />
                <Route exact={true} path="/kontakt" component={Contact} />
                <Route exact={true} path="/anfahrt" component={Way} />
                <Route exact={true} path="/impressum" component={Imprint} />
                <Route exact={true} path="/datenschutz" component={Privacy} />
              </div>
            </HashRouter>
          </div>
        </div>
        <HashRouter>
            <Footer key="footer" />
        </HashRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js